export default "__VITE_ASSET__l$HP9NZF__"